/** @file advanceClock: one update of a clip clock by real seconds (paused clocks stand still). */
import type { ClipClock } from '@zilo/pose3d-runtime-babylon/clip/clipClockTypes';

/**
 * Not paused: `prevTime = time`, `time += dt`, the blend's clip time and elapsed advance too (the blend is dropped once
 * `elapsed >= duration`). Paused: `prevTime = time` and nothing moves (so no event fires twice).
 */
export function advanceClock(clock: ClipClock, dt: number): ClipClock {
  if (clock.paused) return { ...clock, prevTime: clock.time };
  const b = clock.blendFrom;
  const blendFrom = b === null || b.elapsed + dt >= b.duration ? null : { ...b, time: b.time + dt, elapsed: b.elapsed + dt };
  return { ...clock, prevTime: clock.time, time: clock.time + dt, blendFrom };
}
